import { render, staticRenderFns } from "./better_scroll.vue?vue&type=template&id=70f19472"
import script from "./better_scroll.vue?vue&type=script&lang=js"
export * from "./better_scroll.vue?vue&type=script&lang=js"
import style0 from "./better_scroll.vue?vue&type=style&index=0&id=70f19472&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports